export default __webpack_public_path__ + "static/media/logo.61464c1c.svg";